import axios from "axios";
import { CommisionProps } from "../../../../interfaces/Commission/types";
import { restErrorHandler } from '../../../../helpers/restErrorHandler';


export const fetchCommissionData = async ( serialNumber: string, role: string ): Promise<CommisionProps | null | void> => {
    try {
        const response = await axios.get<CommisionProps>(
            `${process.env.REACT_APP_DJANGO_SERVER_URL}/api/${role}/v2/acb/${serialNumber}/commission`,
            { withCredentials: true }
        )
        
        if ( response.status === 200 ) {
            return response.data
        }

        return null
    } catch (error: any) {
        console.log("Error fetching commission details:", error)
        restErrorHandler(error.status)
    }
}
    
    
//     axios.get<CommisionProps>(
//         `${process.env.REACT_APP_DJANGO_SERVER_URL}/api/${role}/v2/acb/${serialNumber}/commission`,
//         { withCredentials: true }
//     )
//     .then(response => {
//         if (response.status === 200) {
//             var data: CommisionProps = response.data
//             setData(data)
//         }
//     })
//     .catch(error => {
//         restErrorHandler(error.status)
//     });
// }